module.exports = __webpack_public_path__ + "img/gbzbg.7bcca9b4.png";